import { toDateString } from './toDateString';
import { getDatePartsAsNumbers } from './getDatePartsAsNumbers';

/**
 * Get the UTC date for a date string. Useful when comparing a DateString from a database to some
 * other date, because JS will create dates in the local timezone by default. Doing comparisons with
 * dates in UTC removes the timezone offset.
 * @param input a string, expected to be a valid DateString, such as '2020-01-31'
 */
export const getUTCDateFromDateString = (input: string): Date => {
    const dateAsDateString = toDateString(input);
    const dateParts = getDatePartsAsNumbers(dateAsDateString);

    if (dateParts === null) {
        throw new Error('Input was not a DateString');
    }

    return new Date(
        Date.UTC(
            dateParts.year,
            dateParts.month - 1,
            dateParts.day,
            0,
            0,
            0,
            0,
        ),
    );
};
